// src/components/MetaTagsUpdater.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Define metadata for different routes
const metaData = {
  "/": {
    title: "Elyte Fitness | Achieve Your Dream Body with Science-Based Coaching",
    description: "Elyte Fitness helps you streamline the process of reaching your dream body. Our science-based approach combines physical therapy expertise with personalized fitness coaching.",
    ogTitle: "Elyte Fitness – Achieve Your Dream Body with Science-Based Coaching",
    ogDescription: "We help you streamline the process of reaching your dream body using a science-based approach to fitness and nutrition.",
    keywords: "Elyte Fitness, personal training, online fitness coaching, weight loss, strength training, physical therapy, customized workout plans, nutrition coaching, fitness goals, Dr. Olu Olapinsin",
    ogUrl: "https://elyte-fitness.com"
  },
  "/about": {
    title: "About Us | Meet Dr. Olu Olapinsin | Elyte Fitness",
    description: "Learn about Dr. Olu Olapinsin, Doctor of Physical Therapy and Certified Strength Coach with over 15 years of experience helping clients achieve their fitness goals.",
    ogTitle: "About Dr. Olu Olapinsin – Founder of Elyte Fitness",
    ogDescription: "Meet Dr. Olu Olapinsin, a Doctor of Physical Therapy and Certified Strength Coach with 15+ years of experience helping clients transform their bodies.",
    keywords: "Dr. Olu Olapinsin, physical therapist, certified strength coach, fitness expert, Elyte Fitness founder, personal trainer, health professional",
    ogUrl: "https://elyte-fitness.com/about"
  },
  "/services": {
    title: "Services | Online & In-Person Fitness Coaching | Elyte Fitness",
    description: "Discover our customized fitness and nutrition coaching services. Choose from online coaching with 24/7 support or VIP in-person training with Dr. Olu Olapinsin.",
    ogTitle: "Fitness & Nutrition Coaching Services – Elyte Fitness",
    ogDescription: "Get customized workout plans, nutrition coaching, and injury prevention strategies with our online or in-person training programs.",
    keywords: "fitness coaching, online personal training, in-person fitness coaching, nutrition plans, workout programs, injury prevention, mobility assessments, weight loss coaching",
    ogUrl: "https://elyte-fitness.com/services"
  },
  "/success-stories": {
    title: "Success Stories | Real Client Transformations | Elyte Fitness",
    description: "See real client transformations and success stories. Our clients have lost up to 50lbs in 6 months with our science-based approach to fitness and nutrition.",
    ogTitle: "Real Client Transformations – Elyte Fitness Success Stories",
    ogDescription: "Browse our gallery of real client transformations and read their testimonials about working with Dr. Olu and the Elyte Fitness team.",
    keywords: "fitness transformations, weight loss success stories, client testimonials, before and after, body transformation, fitness results, Elyte Fitness reviews",
    ogUrl: "https://elyte-fitness.com/success-stories"
  },
  "/pricing": {
    title: "Pricing | Fitness Coaching Packages | Elyte Fitness",
    description: "Explore our flexible fitness coaching packages designed to fit your goals and budget. Request detailed pricing for online coaching or VIP in-person training.",
    ogTitle: "Fitness Coaching Packages – Elyte Fitness Pricing",
    ogDescription: "Find the perfect fitness coaching package for your goals and budget. Flexible options with no long-term contracts required.",
    keywords: "fitness coaching prices, personal training rates, online fitness coaching cost, fitness program pricing, affordable personal training, fitness packages",
    ogUrl: "https://elyte-fitness.com/pricing"
  },
  "/contact": {
    title: "Contact Us | Get Started with Elyte Fitness",
    description: "Ready to transform your body? Contact Elyte Fitness today to schedule a free consultation with Dr. Olu Olapinsin and start your fitness journey.",
    ogTitle: "Contact Elyte Fitness – Start Your Transformation Today",
    ogDescription: "Reach out to our team to learn more about our fitness coaching services or to schedule your free consultation with Dr. Olu.",
    keywords: "contact Elyte Fitness, fitness consultation, personal trainer contact, fitness coaching inquiry, book fitness consultation",
    ogUrl: "https://elyte-fitness.com/contact"
  },
  "/privacy-policy": {
    title: "Privacy Policy | Elyte Fitness",
    description: "Learn about how Elyte Fitness collects, uses, and protects your personal information.",
    ogTitle: "Privacy Policy | Elyte Fitness",
    ogDescription: "Learn more about how Elyte Fitness collects, uses, and protects your personal information.",
    keywords: "privacy policy, data protection, user privacy, Elyte Fitness privacy",
    ogUrl: "https://elyte-fitness.com/privacy-policy"
  },
  "/terms": {
    title: "Terms & Conditions | Elyte Fitness",
    description: "Read the terms and conditions for using Elyte Fitness services and website.",
    ogTitle: "Terms & Conditions | Elyte Fitness",
    ogDescription: "Review our terms and conditions for using Elyte Fitness services and website.",
    keywords: "terms and conditions, legal terms, service terms, Elyte Fitness terms",
    ogUrl: "https://elyte-fitness.com/terms"
  }
};

function MetaTagsUpdater() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Get metadata for current route (default to homepage if route not found)
    const currentMeta = metaData[path] || metaData["/"];
    
    // Update document title
    document.title = currentMeta.title;
    
    // Update meta tags
    const metaTags = {
      description: document.querySelector('meta[name="description"]'),
      keywords: document.querySelector('meta[name="keywords"]'),
      ogTitle: document.querySelector('meta[property="og:title"]'),
      ogDescription: document.querySelector('meta[property="og:description"]'),
      ogUrl: document.querySelector('meta[property="og:url"]'),
      twitterTitle: document.querySelector('meta[name="twitter:title"]'),
      twitterDescription: document.querySelector('meta[name="twitter:description"]')
    };
    
    // Update each meta tag if it exists
    if (metaTags.description) metaTags.description.setAttribute("content", currentMeta.description);
    if (metaTags.keywords) metaTags.keywords.setAttribute("content", currentMeta.keywords);
    if (metaTags.ogTitle) metaTags.ogTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.ogDescription) metaTags.ogDescription.setAttribute("content", currentMeta.ogDescription);
    if (metaTags.ogUrl) metaTags.ogUrl.setAttribute("content", currentMeta.ogUrl);
    if (metaTags.twitterTitle) metaTags.twitterTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.twitterDescription) metaTags.twitterDescription.setAttribute("content", currentMeta.ogDescription);
    
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
}

export default MetaTagsUpdater;